/**
 * ⛔ A ORDEM DE PEGAR A CONTA — Bee primeiro, manual quando ele falha.
 *
 * Douglas, 23/09/2026: "a regra é sempre primeiro o Bee. Se o Bee não pegou, é
 * este ciclo manual."
 *
 * Espelha `services/fatura/ciclo-da-conta.ts` no backend. Mexeu num, mexe no
 * outro — a tela e a régua não podem contar histórias diferentes.
 */

export type EtapaDoCiclo =
  | 'CONTA_OK'
  | 'BEE_EM_VOO'
  | 'BEE_NAO_ACHOU'
  | 'MANUAL_RECUSADO'
  | 'SEM_PEDIDO';

const BEE_EM_VOO = ['AGUARDANDO_ENVIO', 'ENVIADO_N8N', 'PROCESSANDO', 'PROCESSANDO_BEE360', 'AGUARDANDO_STATUS'];
const BEE_FALHOU = ['ERRO_BEE360', 'ERRO_N8N', 'ERRO_ENVIO', 'NAO_ENCONTRADO', 'SUSPENSO', 'TIMEOUT'];

export function etapaDoCiclo(e: {
  temContaLida: boolean;
  ultimoStatusBee?: string | null;
  ultimoAnexoRecusado?: boolean;
}): EtapaDoCiclo {
  if (e.temContaLida) return 'CONTA_OK';
  if (e.ultimoAnexoRecusado) return 'MANUAL_RECUSADO';
  const s = String(e.ultimoStatusBee || '').toUpperCase();
  if (!s) return 'SEM_PEDIDO';
  if (BEE_EM_VOO.includes(s)) return 'BEE_EM_VOO';
  if (BEE_FALHOU.includes(s)) return 'BEE_NAO_ACHOU';
  return 'SEM_PEDIDO';
}

export interface AvisoDoCiclo {
  titulo: string;
  passos: string[];
  /** true = falha real (--danger). false = espera/dívida, que é bordô. */
  ehFalha: boolean;
}

/**
 * O que fazer AGORA, em português de gente. Na A KASPER o consultor anexou dois
 * PDFs, nenhum foi lido, e a tela dizia "Fatura baixada" — ele ficou uma semana
 * achando que estava tudo certo.
 */
export function avisoDoCiclo(etapa: EtapaDoCiclo): AvisoDoCiclo | null {
  switch (etapa) {
    case 'BEE_NAO_ACHOU':
      return {
        titulo: 'O robô não achou a fatura deste cliente',
        passos: [
          'Baixe a conta no SOLAR (segunda via) e anexe aqui em "Anexar PDF".',
          'A conta do SOLAR vem em imagem — o CRM lê, mas não traz GB nem minutos.',
          'Se você não tem acesso ao SOLAR, fale com seu supervisor.',
        ],
        ehFalha: false,
      };
    case 'MANUAL_RECUSADO':
      return {
        titulo: 'O PDF anexado não pôde ser lido — a fatura NÃO foi importada',
        passos: [
          'Baixe a conta de novo no SOLAR, pelo menu de segunda via, e anexe.',
          'Confira se o arquivo é a fatura inteira, e não um recorte ou print de tela.',
          'Se der erro outra vez, fale com seu supervisor.',
        ],
        ehFalha: true,
      };
    case 'BEE_EM_VOO':
      return {
        titulo: 'Pedido feito ao robô — aguardando a conta',
        passos: [
          'A conta costuma chegar sozinha. Não precisa anexar nada ainda.',
          'Se não chegar, o CRM avisa aqui e aí sim você baixa no SOLAR.',
        ],
        ehFalha: false,
      };
    default:
      return null;
  }
}
